import { useState } from 'react';

export const useNotificationTab = () => {
  const [currentTab, setCurrentTab] = useState<string>('jp');
  const handleTabClick = (_event: React.SyntheticEvent, newCurrentTab: string) => {
    setCurrentTab(newCurrentTab);
  };
  return { currentTab, handleTabClick };
};
